var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToggle } from '@hn-front/utils';
import { BlueCheckbox } from '@hn-ui/checkboxes';
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { AccordionContainer, AccordionText, AccordionHeader, AccordionControlContainer, AccordionContentContainer, OpenIcon, } from './Common';
var ChapterText = styled(AccordionText).withConfig({ displayName: "ChapterText", componentId: "sc-1txzn8t" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n"])));
var ChapterAccordion = function (_a) {
    var id = _a.id, text = _a.text, checked = _a.checked, indeterminate = _a.indeterminate, children = _a.children, onAssign = _a.onAssign, onDelete = _a.onDelete, rest = __rest(_a, ["id", "text", "checked", "indeterminate", "children", "onAssign", "onDelete"]);
    var _b = useToggle(), isToggled = _b.isToggled, toggle = _b.toggle;
    var _c = useToggle(checked), isChapterToggled = _c.isToggled, toggleChapter = _c.toggle;
    var handleOnChecked = useCallback(function () {
        toggleChapter();
        if (isChapterToggled)
            onDelete(id);
        else
            onAssign(id);
    }, [onAssign, id, onDelete, isChapterToggled]);
    return (_jsxs(AccordionContainer, __assign({}, rest, { children: [_jsxs(AccordionHeader, { children: [_jsx(BlueCheckbox, { checked: isChapterToggled, indeterminate: indeterminate, onChecked: handleOnChecked }, void 0), _jsxs(AccordionControlContainer, __assign({ onClick: toggle }, { children: [_jsx(ChapterText, { children: text }, void 0), _jsx(OpenIcon, { open: isToggled }, void 0)] }), void 0)] }, void 0), isToggled && (_jsx(AccordionContentContainer, { children: children }, void 0))] }), void 0));
};
export { ChapterAccordion };
var templateObject_1;
